import type { FaireProductEntity } from "../../entity_types/product";

export const p_yc6nyrnx9e: FaireProductEntity = {
  token: "p_yc6nyrnx9e",
  type: "product",
  name: "Love You Till the Cows Come Home Wood Sign",
  brandName: "WillowBee Signs & Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/10f55dee76473ed4a74c69f9d4b1055466e85c1f4181f20467cfb239572c9563.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/5c885a4ba44b7b1ff1b6555807618a2315ee746acfbe197071b4960690b19e39.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
